import { render, staticRenderFns } from "./ManageProducts.vue?vue&type=template&id=0de590b6&"
import script from "./ManageProducts.vue?vue&type=script&lang=ts&"
export * from "./ManageProducts.vue?vue&type=script&lang=ts&"
import style0 from "./ManageProducts.vue?vue&type=style&index=0&id=0de590b6&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports